'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _NAME_LABELS;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('I18n/components');

var _utils = require('I18n/utils');

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UIBox = require('UIComponents/layout/UIBox');

var _UIBox2 = _interopRequireDefault(_UIBox);

var _customRenderer = require('UIComponents/utils/propTypes/customRenderer');

var CustomRenderer = _interopRequireWildcard(_customRenderer);

var _sizes = require('HubStyleTokens/sizes');

var _Style = require('UIComponents/core/Style');

var _NameTypes = require('../constants/NameTypes');

var _NameTypes2 = _interopRequireDefault(_NameTypes);

var _SingleNameInput = require('../internal/components/SingleNameInput');

var _SingleNameInput2 = _interopRequireDefault(_SingleNameInput);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FORMATS = {
  default: [_NameTypes2.default.GIVEN_NAME, _NameTypes2.default.FAMILY_NAME],
  ja: [_NameTypes2.default.FAMILY_NAME, _NameTypes2.default.GIVEN_NAME]
};

var NAME_LABELS = (_NAME_LABELS = {}, _defineProperty(_NAME_LABELS, _NameTypes2.default.GIVEN_NAME, function () {
  return _react2.default.createElement(_components.FormattedMessage, { message: 'i18nAddon.fullNameInput.givenName' });
}), _defineProperty(_NAME_LABELS, _NameTypes2.default.FAMILY_NAME, function () {
  return _react2.default.createElement(_components.FormattedMessage, { message: 'i18nAddon.fullNameInput.familyName' });
}), _NAME_LABELS);

var nameMargin = parseInt(_sizes.BASE_SPACING_X, 10);

exports.default = _react2.default.createClass({
  displayName: 'FullNameInput',

  propTypes: {
    direction: _react.PropTypes.oneOf(['row', 'column']),
    familyNameInput: CustomRenderer.propType.isRequired,
    givenNameInput: CustomRenderer.propType.isRequired,
    wrap: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      direction: 'column',
      wrap: 'nowrap'
    };
  },
  render: function render() {
    var _props = this.props,
        direction = _props.direction,
        familyNameInput = _props.familyNameInput,
        firstInputProps = _props.firstInputProps,
        givenNameInput = _props.givenNameInput,
        secondInputProps = _props.secondInputProps,
        wrap = _props.wrap;

    var lang = (0, _utils.getLang)();
    var format = FORMATS[lang] ? FORMATS[lang] : FORMATS.default;
    var firstInputType = format[0];
    var secondInputType = format[1];
    var firstLabel = NAME_LABELS[firstInputType];
    var secondLabel = NAME_LABELS[secondInputType];
    var isRow = direction === 'row';
    var wrapBoxStyle = isRow ? { margin: (0, _Style.remCalc)(nameMargin) } : null;
    var flexBoxStyle = isRow ? { margin: (0, _Style.remCalc)(nameMargin * -1) } : null;
    var containerStyle = isRow ? { marginRight: (0, _Style.remCalc)(nameMargin * -2) } : null;

    var firstInput = givenNameInput;
    var secondInput = familyNameInput;
    if (firstInputType === _NameTypes2.default.FAMILY_NAME) {
      firstInput = familyNameInput;
      secondInput = givenNameInput;
    }

    return _react2.default.createElement(
      'div',
      { style: containerStyle },
      _react2.default.createElement(
        _UIFlex2.default,
        {
          direction: direction,
          wrap: wrap,
          align: 'stretch',
          style: flexBoxStyle
        },
        _react2.default.createElement(
          _UIBox2.default,
          { grow: 1, style: wrapBoxStyle },
          _react2.default.createElement(_SingleNameInput2.default, _extends({}, firstInputProps, {
            input: firstInput,
            label: firstLabel
          }))
        ),
        _react2.default.createElement(
          _UIBox2.default,
          { grow: 1, style: wrapBoxStyle },
          _react2.default.createElement(_SingleNameInput2.default, _extends({}, secondInputProps, {
            input: secondInput,
            label: secondLabel
          }))
        )
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.1352/js/components/FullNameInput.js
// module id = 480
// module chunks = 0